import { useLang } from "../lib/i18n";
import { appCopy } from "../lib/i18n/app";

// DESIGN.md sec 12: visible footer on settings/profile screens.
export function CrisisSupportFooter() {
  const { lang } = useLang();
  const t = appCopy[lang];
  return (
    <p className="text-caption text-[var(--muted)] text-center px-4">
      {t.crisisSupport}{" "}
      <a href={t.helplineHref} className="text-[var(--accent)] underline">
        {t.helplineLabel}
      </a>
      .
    </p>
  );
}
